import styled from 'styled-components';

const ParagraphsContainer = styled.div`
  height: 100%;
  overflow: hidden;

  #tingwu_paragraphs_scrollContainer {
    padding-left: 32px;
    padding-right: 32px;

    .transcriptionContent {
    }
  }

  .tongyi_lixian {
    padding-right: 1.5px;
  }
`;

const TabContainer = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
`;

export { ParagraphsContainer, TabContainer };
